import Aos from "aos";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { getBirthStone } from "../../modules/actions";
import "./home.scss";

function YourStone(props) {
  useEffect(() => {
    document.title =
      "Gemology | Your Birth Stone | Galaxy Gemological Institute";
    window.scrollTo(0, 0);
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });

  const [yourName, setYourName] = useState(null);
  const [phoneNo, setPhoneNo] = useState(null);
  const [email, setEmail] = useState(null);
  const [placeofbirth, setPlaceofbirth] = useState(null);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [message, setMessage] = useState(null);

  const onSubmit = (e) => {
    props.getBirthStone({
      yourName: yourName,
      phoneNo: phoneNo,
      email: email,
      placeofbirth: placeofbirth,
      date: date,
      time: time,
      message: message,
    }, resetForm);
  };
  const resetForm = () => {
    setYourName('')
    setPhoneNo('')
    setEmail('')
    setPlaceofbirth('')
    setDate('')
    setTime('')
    setMessage('')
  }
  return (
    <div className="BirthStone">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/gemology/YourBirthStone"
        />
        <title>
          Gemology | Your Birth Stone | Galaxy Gemological Institute
        </title>
        <meta
          name="description"
          content="Find your birthstone with GGILab! We offer a comprehensive list of birthstones by month, along with information on their history, symbolism, and properties."
        />
      </Helmet>
      <div className="innerBirthStone">
        <div className="sec1">
          <div className="serveForm">
            <div className="container row">
              <div className="sec1Content col-lg-7 col-md-12 col-sm-12">
                <div className="sec1Head">
                  <h6 className="small-title" data-aos="flip-left">
                    Find Best For You
                  </h6>
                  <h1 data-aos="fade-down">
                    Find your
                    <br />
                    <span>
                      Birth Stone <br />
                    </span>{" "}
                    With Our Experts
                  </h1>
                </div>
              </div>
              <div className="sec1Content posRel col-lg-5 col-md-10 col-sm-12">
                <div className="formDiv">
                  {props.birthStone ? (
                    <div className="SuccessForm formSurvey">
                      <h2 data-aos="fade-right">
                        Your Query Has been Received We Would Contact You Back
                        Soon
                      </h2>
                    </div>
                  ) : (
                    <div className="formSurvey">
                      <h2 className="title" data-aos="zoom-in-up">
                        PLEASE FILL THIS FORM SO WE CAN FIND BEST STONE FOR YOU
                        !
                      </h2>
                      <input
                        data-aos="zoom-in"
                        placeholder="Your Name"
                        value={yourName}
                        onChange={(e) => setYourName(e.target.value)}
                      />
                      <input
                        data-aos="zoom-in"
                        placeholder="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <input
                        data-aos="zoom-in"
                        placeholder="Phone No."
                        value={phoneNo}
                        onChange={(e) => setPhoneNo(e.target.value)}
                      />
                      <input
                        data-aos="zoom-in"
                        placeholder="Date Of Birth"
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                      />
                      <input
                        data-aos="zoom-in"
                        placeholder="Time Of Birth"
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                      />
                      <input
                        data-aos="zoom-in"
                        placeholder="Place Of Birth"
                        value={placeofbirth}
                        onChange={(e) => setPlaceofbirth(e.target.value)}
                      />

                      <textarea
                        data-aos="zoom-in"
                        placeholder="Message"
                        rows="5"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      ></textarea>
                      <button
                        type="submit"
                        onClick={() => onSubmit()}
                        data-aos="flip-right"
                      >
                        {props.birthStoneLoader ?
                          <div class="spinner-border text-danger" role="status">
                          </div>
                          :
                          `SEND MESSAGE`
                        }
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  birthStone: state.store.birthStone,
  birthStoneLoader: state.store.birthStoneLoader
});

export default connect(mapStateToProps, { getBirthStone })(YourStone);